export default "__VITE_ASSET__e8OGLAUe__"